import { defineStore } from "pinia";

export const useViewSelector = defineStore("viewSelector", {
  state: () => {
    return {
      currentView: "Login",
    };
  },
});